import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import client from './GraphqlConfig'
import { Provider } from 'react-redux';
import { store } from './redux/store';
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ApolloProvider client={client}>
        <App />
          <TawkMessengerReact
           propertyId="68481b7ff2d8e4190fa58f3f"
           widgetId="1itcqmqvp"
         />
      </ApolloProvider>
    </Provider>
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
